import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { CopyToClipboardButton } from '@sorare/core/src/atoms/buttons/CopyToClipboardButton';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconDuplicate } from '@sorare/core/src/atoms/icons/system/iconDuplicate.ts';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BodyM } from '@sorare/core/src/atoms/typography';
import { useIntlContext } from '@sorare/core/src/contexts/intl';
import { useSnackNotificationContext } from '@sorare/core/src/contexts/snackNotification';
import { useCopyToClipboard } from '@sorare/core/src/hooks/useCopyToClipboard';

const CodeField = styled(Horizontal)`
  flex: 1;
  background: var(--c-black);
  border: 1px dashed var(--c-nd-150);
  border-radius: var(--unit);
  padding: var(--unit) var(--double-unit);
  justify-content: space-between;
  position: relative;
`;

type Props = {
  joinSecret: string;
};

export const JoinSecretShare = ({ joinSecret }: Props) => {
  const copyToClipboard = useCopyToClipboard();
  const { formatMessage } = useIntlContext();
  const { showNotification } = useSnackNotificationContext();

  return (
    <Horizontal gap={1}>
      <CodeField gap={1}>
        <BodyM color="var(--c-white)">{joinSecret}</BodyM>
        <CopyToClipboardButton textToCopy={joinSecret}>
          <FontAwesomeIcon icon={iconDuplicate} color="var(--c-white)" />
        </CopyToClipboardButton>
      </CodeField>
      <Button
        size="medium"
        color="secondary"
        onClick={() => {
          const shareProps = {
            title: formatMessage(
              {
                defaultMessage: 'Join my Squad on Sorare! {link}',
              },
              {
                // to be replaced with final link
                // oxlint-disable-next-line sorare/no-window-location
                link: `${window.location.origin}?joinSecret=${joinSecret}`,
              }
            ),
          };
          if (navigator.canShare(shareProps)) {
            navigator.share(shareProps);
          } else {
            copyToClipboard(shareProps.title);
            showNotification('copiedToClipboard');
          }
        }}
      >
        <FormattedMessage defaultMessage="Invite Friends" />
      </Button>
    </Horizontal>
  );
};
